import { createSlice } from "@reduxjs/toolkit";

interface PortofolioInitialStateModel {
  filter: any;
}
const PortofolioInitialState: PortofolioInitialStateModel = {
  filter: {
    PageSize: 20,
    PageIndex:1,
    IncludeProperties: [
      "User",
      "Store",
      "Currency",
      "Country",
      "City",
      "District",
      "Neighbourhood",
      "AdvertMedia",
      "AdvertMedia.Media",
      "AdvertContactType",
      "AdvertContactType.ContactType",

    ],
    SortProperty: "price",
    SortType: "asc",
  },
};
      // "AdvertOptionAttr"
const portofolioSlice = createSlice({
  name: "PortofolioSlice ",
  initialState: PortofolioInitialState,
  reducers: {
    handleSetPortofolioFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetPortofolioFitler: (state) => {
      state.filter = {
        PageSize: -1,
        IncludeProperties: [
          "User",
          "Store",
          "Currency",
          "Country",
          "City",
          "District",
          "Neighbourhood",
          "AdvertMedia",
          "AdvertMedia.Media",
          "AdvertContactType",
          "AdvertContactType.ContactType",
        ],
        SortProperty: "price",
        SortType: "asc",
      };
    },
  },
});
// "advertOptionAttr",

export const { handleSetPortofolioFilter, handleResetPortofolioFitler } =
  portofolioSlice.actions;
export default portofolioSlice;
